import React, { useState } from "react";
import Layout from "../../../components/common/Layout";
import SalaryComponentToolbar from "../../../components/finance/payroll/salary-components/SalaryComponentToolbar";
import SalaryComponentsTable from "../../../components/finance/payroll/salary-components/SalaryComponentsTable";
import SalaryComponentModal from "../../../components/finance/payroll/salary-components/SalaryComponentModal";
import { ADMIN_NAV } from "../../../utils/navigation";
import { salaryComponents as initialSalaryComponents } from "../../../data/payrollMockData";

const SalaryComponents = () => {
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");

  const [components, setComponents] = useState(initialSalaryComponents);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState(null);

  const handleSaveComponent = (componentData) => {
    if (selectedComponent) {
      setComponents((prev) =>
        prev.map((item) =>
          item.id === selectedComponent.id
            ? {
                ...componentData,
                id: selectedComponent.id,
              }
            : item
        )
      );
    } else {
      setComponents((prev) => [
        ...prev,
        {
          ...componentData,
          id: Date.now(),
        },
      ]);
    }

    setSelectedComponent(null);
    setIsModalOpen(false);
  };

  const handleDeleteComponent = (id) => {
  const confirmDelete = window.confirm(
    "Are you sure you want to delete this salary component?"
  );

  if (!confirmDelete) return;

  setComponents((prev) =>
    prev.filter((component) => component.id !== id)
  );
};

  return (
    <Layout navItems={ADMIN_NAV}>
      <div className="page-container">
        <div className="page-header">
          <h2>Salary Components</h2>
          <p>
            Manage salary earning and deduction components used in payroll.
          </p>
        </div>

        <SalaryComponentToolbar
          search={search}
          setSearch={setSearch}
          typeFilter={typeFilter}
          setTypeFilter={setTypeFilter}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          onAdd={() => {
            setSelectedComponent(null);
            setIsModalOpen(true);
          }}
        />

        <SalaryComponentsTable
  components={components}
  search={search}
  typeFilter={typeFilter}
  statusFilter={statusFilter}
  onEdit={(component) => {
    setSelectedComponent(component);
    setIsModalOpen(true);
  }}
  onDelete={handleDeleteComponent}
/>

        <SalaryComponentModal
          isOpen={isModalOpen}
          onClose={() => {
            setSelectedComponent(null);
            setIsModalOpen(false);
          }}
          onSave={handleSaveComponent}
          initialData={selectedComponent}
        />
      </div>
    </Layout>
  );
};

export default SalaryComponents;